import type { StateCreator } from 'zustand'
import type { AppStore } from '../useStore'

export interface SystemSlice {
  latestRevision: number | null
  setRevision: (rev: number) => void
  clearRevision: () => void
  isStale: (renderedRev: number | null) => boolean
  modelFloorIso: string | null
  setModelFloorIso: (iso: string | null) => void
}

export const createSystemSlice: StateCreator<AppStore, [], [], { system: SystemSlice }> = (
  set,
  get,
) => ({
  system: {
    latestRevision: null,
    setRevision: (rev) => set((s) => ({ system: { ...s.system, latestRevision: rev } })),
    clearRevision: () => set((s) => ({ system: { ...s.system, latestRevision: null } })),
    isStale: (renderedRev) => {
      const latest = get().system.latestRevision
      if (latest === null || renderedRev === null) return false
      return latest > renderedRev
    },
    modelFloorIso: null,
    setModelFloorIso: (iso) => set((s) => ({ system: { ...s.system, modelFloorIso: iso } })),
  },
})
